export default __webpack_public_path__ + "static/media/drag.bf180ce8.svg";